// ── 업무 단계 배지 + 발주/완료 체크박스 컴포넌트 ────────────────────────────────
import React from 'react';

// 업무 단계 순차 배지 (배송불필요 아이템 custom_steps 전용)
// 마지막 단계도 노란색 유지 — 녹색은 행 배경(아이템 전체 택배 입력 시)으로만 표현
export function WorkflowStepBadge({ stepId, steps, onStepChange }) {
  const activeSteps = (steps || []).filter((s) => s.is_active);
  if (!activeSteps.length) return null;

  const currentIdx  = stepId ? activeSteps.findIndex((s) => s.id === Number(stepId)) : -1;
  const isPending   = currentIdx === -1;
  const currentStep = currentIdx >= 0 ? activeSteps[currentIdx] : null;
  const totalSteps  = activeSteps.length;

  // 미시작=회색, 진행중/마지막 모두 앰버 (마지막도 노란색)
  const col = isPending
    ? { bg: 'var(--bg-subtle)', text: 'var(--text-muted)', border: 'var(--border)' }
    // 다크모드 대응: 반투명 앰버 색상 사용
    : { bg: 'rgba(234,179,8,0.12)', text: '#d97706', border: 'rgba(234,179,8,0.4)' };

  const navBtn = {
    border: 'none', background: 'transparent', cursor: 'pointer',
    padding: '0 5px', color: col.text, fontSize: 13, fontWeight: 700,
    lineHeight: '22px', flexShrink: 0,
  };

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center',
      border: `1px solid ${col.border}`, borderRadius: 12,
      background: col.bg, overflow: 'hidden', flexShrink: 0, height: 22,
    }}>
      {!isPending && (
        <button type="button"
          style={{ ...navBtn, borderRight: `1px solid ${col.border}` }}
          onClick={(e) => { e.stopPropagation(); onStepChange(currentIdx > 0 ? activeSteps[currentIdx - 1].id : null); }}>
          ‹
        </button>
      )}
      <span
        style={{ padding: '0 7px', fontSize: 11, fontWeight: 700, color: col.text, whiteSpace: 'nowrap', cursor: isPending ? 'pointer' : 'default', lineHeight: '22px' }}
        onClick={isPending ? (e) => { e.stopPropagation(); onStepChange(activeSteps[0].id); } : undefined}
      >
        {isPending ? '시작' : currentStep.name}
      </span>
      {/* 완료 버튼 — 미시작이거나 마지막 단계에서는 숨김 */}
      {!isPending && currentIdx < totalSteps - 1 && (
        <button type="button"
          style={{ ...navBtn, borderLeft: `1px solid ${col.border}`, padding: '0 8px', fontSize: 11 }}
          onClick={(e) => { e.stopPropagation(); onStepChange(activeSteps[currentIdx + 1].id); }}>
          완료
        </button>
      )}
    </div>
  );
}

// 발주 체크박스 — is_ordered 기반 하드코딩, ordered_by 표시
export function OrderedCheckbox({ isOrdered, orderedBy, onToggle }) {
  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
      <label
        style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 11, cursor: 'pointer', userSelect: 'none' }}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          checked={Boolean(isOrdered)}
          onChange={() => onToggle()}
          style={{ cursor: 'pointer', width: 13, height: 13, accentColor: '#7c3aed', flexShrink: 0 }}
        />
        <span style={{ color: isOrdered ? '#15803d' : 'var(--text-muted)', fontWeight: isOrdered ? 700 : 400 }}>
          발주
        </span>
      </label>
      {isOrdered && orderedBy && (
        <span style={{ fontSize: 10, color: '#7c3aed', paddingLeft: 16, whiteSpace: 'nowrap' }}>{orderedBy}</span>
      )}
    </div>
  );
}

// 완료 체크박스 — 송장불필요 품목 전용, is_ordered를 완료 상태로 활용
// 체크 → 즉시 완료(녹색) 상태로 전환, 체크 해제 → 미완료 상태로 복원
export function CompletedCheckbox({ isCompleted, completedBy, onToggle }) {
  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
      <label
        style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 11, cursor: 'pointer', userSelect: 'none' }}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          checked={Boolean(isCompleted)}
          onChange={() => onToggle()}
          style={{ cursor: 'pointer', width: 13, height: 13, accentColor: '#15803d', flexShrink: 0 }}
        />
        <span style={{ color: isCompleted ? '#15803d' : 'var(--text-muted)', fontWeight: isCompleted ? 700 : 400 }}>
          완료
        </span>
      </label>
      {isCompleted && completedBy && (
        <span style={{ fontSize: 10, color: '#15803d', paddingLeft: 16, whiteSpace: 'nowrap' }}>{completedBy}</span>
      )}
    </div>
  );
}
